var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5563 0.458833C19.2729 0.174794 18.8882 0.0151688 18.4869 0.0151688C18.0857 0.0151688 17.7009 0.174794 17.4175 0.458833L10 7.86119L2.58248 0.443665C2.29908 0.159625 1.91432 0 1.51308 0C1.11184 0 0.727086 0.159625 0.443686 0.443665C-0.147895 1.03525 -0.147895 1.99088 0.443686 2.58246L7.86121 9.99999L0.443686 17.4175C-0.147895 18.0091 -0.147895 18.9647 0.443686 19.5563C1.03527 20.1479 1.9909 20.1479 2.58248 19.5563L10 12.1388L17.4175 19.5563C18.0091 20.1479 18.9647 20.1479 19.5563 19.5563C20.1479 18.9647 20.1479 18.0091 19.5563 17.4175L12.1388 9.99999L19.5563 2.58246C20.1327 2.00605 20.1327 1.03525 19.5563 0.458833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhite);
export default __webpack_public_path__ + "static/media/close_white.1c1873a2c45c3beeb0e9a3029a59e731.svg";
export { ForwardRef as ReactComponent };